(function () {
  document.documentElement.classList.add('taro-js');
  function init() {
    var els = [].slice.call(document.querySelectorAll('[data-reveal]'));
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('is-visible');
            io.unobserve(en.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      els.forEach(function (el) { io.observe(el); });
    }
    document.querySelectorAll('.store-cart input[name^="updates"]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var f = inp.closest('form');
        if (f) f.submit();
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
